"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.frequencyToNumber = void 0;
/**
 * Takes the frenquency in text format and returns interval in blocks
 * @param {string} frequency The frequency interval on text format
 * @returns {number} The frequency in blocks
 */
function frequencyToNumber(frequency) {
    if (frequency === 'day')
        return 17280;
    if (frequency === 'week')
        return 120960;
    return 0;
}
exports.frequencyToNumber = frequencyToNumber;
//# sourceMappingURL=frequencyToNumber.js.map